export enum E_CUSTOMER_ON_BOARDING_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED'
}

export enum E_HOMEPAGE_LINK_ITEM_TYPE {
  CATEGORY = 'category',
  CUSTOM = 'custom',
  PAGE = 'page',
  PRODUCT = 'product',
}

export enum E_FOOTER_COL_ITEM_TYPE {
  CATEGORIES = 'categories',
  FAQS = 'faqs',
  PAGES = 'pages',
  PRODUCTS = 'products',
}

export enum E_FOOTER_COL_ITEM_TYPE_URL_PATH {
  CATEGORIES = 'category',
  FAQS = 'faqs',
  PAGES = 'content',
  PRODUCTS = 'product',
}

export enum E_CATEGORY_TYPE {
  PRODUCT = 'PRODUCT',
  FAQ = 'FAQ'
}

export enum E_BANNER_TYPE {
  MAIN = 'MAIN',
  VIDEO = 'VIDEO',
  SERVICE = 'SERVICE',
  SLIM = 'SLIM',
}

export enum E_PAGE_TYPE {
  HOME = 'HOME',
  REGULAR = 'REGULAR'
}

export enum E_ADDRESS_TYPE {
  ANY = 'ANY',
  BILLING = 'BILLING',
  SHIPPING = 'SHIPPING',
}

export enum E_CART_LINE_TYPE {
  GIFT_CERTIFICATE = 'GIFT_CERTIFICATE',
  PHYSICAL = 'PHYSICAL',
  SERVICE = 'SERVICE'
}

export enum E_POSTAL_CODE_TYPE {
  RANGE = 'RANGE',
  SINGLE = 'SINGLE',
}

/**
 * Variants delivery types:
 * - Stocked -> Always has stock, can be purchased anytime
 * - On Demand -> Inventory Tracking: FALSE (this variants ignores stock), can be purchased anytime
 * - Frozen -> Cannot be purchased with Stocked and / or On Demand
**/
export enum E_DELIVERY_TYPE {
  FROZEN = 'FROZEN',
  ON_DEMAND = 'ON_DEMAND',
  STOCKED = 'STOCKED',
}

/**
 * Cart Delivery Types:
 * - Fresh -> Cart with only Stocked and On Demand variants
 * - Frozen -> Cart with only Frozen variants
 */
export enum E_CART_DELIVERY_TYPE {
  FRESH = 'FRESH',
  FROZEN = 'FROZEN',
}

/**
 * - Exception in backend will be a string with any value.
 * - But those are the common ones (otherwise -> 'fallback' value)
**/
export enum E_CUSTOMER_PAYMENT_METHOD {
  CHECK = 'check',
  DELIVERY = 'delivery',
  FALLBACK = 'fallback',
  GIRO = 'giro',
  TRANSFERENCIA = 'transferencia',
}

export enum E_FILTER_TYPE {
  BOOLEAN = 'BOOLEAN', // BOOLEAN
  SELECT = 'SELECT', // SELECT
}

export enum E_CONTENT_COLUMN_TYPE {
  BUTTON_DOWNLOAD = 'BUTTON_DOWNLOAD',
	BUTTON_LINK = 'BUTTON_LINK',
  EMPTY = 'EMPTY',
  MEDIA = 'MEDIA',
  // PRODUCTS = 'PRODUCTS',
  SPACER = 'SPACER',
  TEXT = 'TEXT',
}

export enum E_CONTENT_HORIZONTAL_ALIGNMENT {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum E_CONTENT_VERTICAL_ALIGNMENT {
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
}

export enum E_CONTENT_MEDIA_SIZE {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  BIG = 'BIG',
}

export enum E_CONTENT_MEDIA_TYPE {
  MEDIUM_IMAGE = 'MEDIUM_IMAGE',
  MEDIUM_VIDEO = 'MEDIUM_VIDEO',
}

export enum E_VIDEO_PLATFORM {
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE',
}

export enum E_MEDIUM_IMAGE_STATUS {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
}

export enum E_IMPORT_STATUS {
  ARCHIVED = 'ARCHIVED',
  IMPORTING = 'IMPORTING',
  IMPORTED = 'IMPORTED',
  TO_DELETE = 'TO_DELETE',
}

export enum E_PRODUCT_NUTRITION_TYPE {
  ENERGY = 'ENERGY',
  WEIGHT = 'WEIGHT',
}

export enum E_PRODUCT_SPECIFICATION_TYPE {
  INFO = 'INFO',
  NUTRITION = 'NUTRITION',
}

export enum E_VARIANT_TYPE {
  REGULAR = 'REGULAR',
  PACK = 'PACK',
}
